import { katTranslator } from '../../shared/i18n';

const strings = {
  'kat-star-rating-star': {
    'en-US': 'star',
    'ar-AE': 'نجمة',
    'bn-IN': 'স্টার',
    'de-DE': 'Stern',
    'es-ES': 'estrella',
    'es-MX': 'estrella',
    'fr-BE': 'étoile',
    'fr-FR': 'étoile',
    'gu-IN': 'સ્ટાર',
    'hi-IN': 'स्टार',
    'it-IT': 'stella',
    'ja-JP': '星',
    'kn-IN': 'ಸ್ಟಾರ್',
    'ko-KR': '별 1개',
    'ml-IN': 'സ്‌റ്റാർ',
    'mr-IN': 'स्टार',
    'nl-BE': 'ster',
    'nl-NL': 'ster',
    'pl-PL': 'gwiazdka',
    'pt-BR': 'estrela',
    'pt-PT': 'estrela',
    'sv-SE': 'stjärna',
    'ta-IN': 'ஸ்டார்',
    'te-IN': 'స్టార్',
    'th-TH': 'ดาว',
    'tr-TR': 'yıldız',
    'vi-VN': 'sao',
    'zh-CN': '星级',
    'zh-TW': '星級',
  },
  'kat-star-rating-stars': {
    'en-US': 'stars',
    'ar-AE': 'نجوم',
    'bn-IN': 'স্টার',
    'de-DE': 'Sterne',
    'es-ES': 'estrellas',
    'es-MX': 'estrellas',
    'fr-BE': 'étoiles',
    'fr-FR': 'étoiles',
    'gu-IN': 'સ્ટાર્સ',
    'hi-IN': 'स्टार',
    'it-IT': 'stelle',
    'ja-JP': '星',
    'kn-IN': 'ಸ್ಟಾರ್‌ಗಳು',
    'ko-KR': '별 여러 개',
    'ml-IN': 'സ്റ്റാറുകൾ',
    'mr-IN': 'स्टार्स',
    'nl-BE': 'sterren',
    'nl-NL': 'sterren',
    'pl-PL': 'gwiazdki',
    'pt-BR': 'estrelas',
    'pt-PT': 'estrelas',
    'sv-SE': 'stjärnor',
    'ta-IN': 'ஸ்டார்கள்',
    'te-IN': 'స్టార్‌లు',
    'th-TH': 'ดาว',
    'tr-TR': 'yıldız',
    'vi-VN': 'sao',
    'zh-CN': '星级',
    'zh-TW': '星級',
  },
};

export default katTranslator(strings);
